import React from 'react';
import { Badge, Group, Stack, Tabs, Text, Title } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../components/ui/PageContainer';
import { usePermission } from '../../hooks/usePermission';
import { RolesTab } from './RolesTab';
import { PeopleTab } from './PeopleTab';
import { WhyTab } from './WhyTab';
import { AuditTab } from './AuditTab';

const TABS = [
  { value: 'roles', path: '/roles', permission: 'company.roles' },
  { value: 'people', path: '/roles/people', permission: 'company.roles' },
  { value: 'why', path: '/roles/why', permission: 'company.roles' },
  { value: 'audit', path: '/roles/audit', permission: 'company.audit' },
] as const;

/** «Роли и права» (бета). Вкладка — в адресе; маршрут сам проверяет право своей вкладки. */
export const RolesPage: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const canRoles = usePermission('company.roles');
  const canAudit = usePermission('company.audit');
  const visible = TABS.filter((tab) => (tab.permission === 'company.roles' ? canRoles : canAudit));
  const active = TABS.find((tab) => tab.path === pathname)?.value ?? 'roles';

  return (
    <PageContainer>
      <Stack gap="lg">
        <div>
          <Group gap="xs" align="center">
            <Title order={2}>{t('roles.title')}</Title>
            <Badge variant="light" color="teal" size="sm">
              {t('roles.beta')}
            </Badge>
          </Group>
          <Text size="sm" c="dimmed" mt={4} maw={640}>
            {t('roles.subtitle')}
          </Text>
        </div>
        <Tabs
          value={active}
          onChange={(v) => navigate(TABS.find((tab) => tab.value === v)!.path)}
          color="teal"
          keepMounted={false}
        >
          <Tabs.List mb="lg" style={{ flexWrap: 'nowrap', overflowX: 'auto' }}>
            {visible.map((tab) => (
              <Tabs.Tab key={tab.value} value={tab.value} style={{ flexShrink: 0 }}>
                {t(`roles.tabs.${tab.value}`)}
              </Tabs.Tab>
            ))}
          </Tabs.List>
          <Tabs.Panel value="roles">
            <RolesTab />
          </Tabs.Panel>
          <Tabs.Panel value="people">
            <PeopleTab />
          </Tabs.Panel>
          <Tabs.Panel value="why">
            <WhyTab />
          </Tabs.Panel>
          <Tabs.Panel value="audit">
            <AuditTab />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </PageContainer>
  );
};
